/** @format */

import React from "react";
import GlobalRoutes from "./routes";
import { ConfigProvider } from "antd";
import usePageTiming from "./utils/usePageTiming";

const App = () => {
  usePageTiming();
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#29405f",
        },
      }}
    >
      <GlobalRoutes />
    </ConfigProvider>
  );
};

export default App;
